export default __webpack_public_path__ + "static/media/rank-24dp.41c14fa6.svg";